module.exports = __webpack_public_path__ + "static/media/Cart-big.07f52cef.png";